import styled from 'styled-components';
export const ButtonsContainer = styled.div`
	padding: 18px 16px !important;
	display: flex !important;
	flex-direction: column !important;
	gap: 0 !important;
	justify-content: center !important;
	align-items: center !important;
`;

export const OtherMethodLink = styled.button`
	margin: 10px 0 4px !important;
	padding: 0 !important;
	border: 0 !important;
	background: transparent !important;
	cursor: pointer !important;
	font-size: 13px !important;
	font-weight: 500 !important;
	text-decoration: underline !important;
	color: var(--ticto-text) !important;
`;
